var React = require('react');
var ReactNative = require('react-native');



var Animated = require('./wrappers/Animated')

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKButton,
} = MK;

import Icon from './wrappers/ReUpIcon';

var {
  AppRegistry,
  Text,
  View,
  StyleSheet,
  Platform,
} = ReactNative;

var ReUpText = require('./ReUpText');

var ReUpButton = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager: {},
      text: "",
      isSecondary: false,
      useShadow: true,
      isTertiary: false,
      enabled:true,
    }
  },

  getInitialState : function()
  {
    return {
      text:this.props.text
    }
  },

  componentWillReceiveProps: function(newProps)
  {
    if( typeof newProps.text !== 'undefined' ) this.setTitle(newProps.text);
  },

  setTitle : function(newText)
  {
    this.setState({text:newText})
  },

  render: function()
  {
    var {text, appManager, icon, isSecondary, isTertiary, isSkip, style, ...other} = this.props;

    if( Platform.OS == 'web' ) other.tabindex = -1;

    var text = this.state.text;
    if( appManager.useCapsButtons() ) text = text.toUpperCase();
    isSecondary = typeof isSecondary !== 'undefined' && isSecondary;
    isTertiary = typeof isTertiary !== 'undefined' && isTertiary;
    isSkip = typeof isSkip !== 'undefined' && isSkip;

    var maskBorderRadius = 4;
    if( appManager.buttonType() == 2 ) maskBorderRadius = 10;
    if( appManager.buttonType() == 1 ) maskBorderRadius = 0;
    if( typeof this.props.icon !== 'undefined' && text.length <= 0 ) maskBorderRadius = 12;
    if( typeof this.props.maskBorderRadius !== 'undefined' ) maskBorderRadius = this.props.maskBorderRadius;

    var buttonColor = typeof this.props.buttonColor !== 'undefined' ? this.props.buttonColor : (isSecondary ? appManager.getColorForKey("ButtonSecondaryColor") : appManager.getColorForKey("ButtonPrimaryColor"));
    var buttonTitleColor = typeof this.props.buttonTitleColor !== 'undefined' ? this.props.buttonTitleColor : (isSecondary ? appManager.getColorForKey("ButtonSecondaryTitleColor") : appManager.getColorForKey("ButtonPrimaryTitleColor"));
    var buttonBorderColor = isSecondary ? appManager.getColorForKey("ButtonSecondaryBorderColor") : appManager.getColorForKey("ButtonPrimaryBorderColor");

    var rippleColor = isSecondary ? appManager.getColorForKey("ButtonPrimaryColor", 0.4) : appManager.getColorForKey("ButtonSecondaryColor", 0.4)

    var fontSize = 20;
    var moreStyle =  {justifyContent:'center', height:40, borderRadius:maskBorderRadius, elevation:2};

    if( isSkip )
    {
      buttonColor = appManager.getColorForKey("HeaderColor");
      buttonTitleColor = appManager.getColorForKey("HeaderIconColor");
      buttonBorderColor = 'transparent';
      moreStyle.height = 30;
      fontSize = 16;
      moreStyle.elevation = 0;
    }

    if( typeof style === 'undefined' ) style = {};
    style = [moreStyle, style];

    if( this.props.isTertiary )
    {
      var internalContainerStyle = {flexDirection:'row', alignItems:'center', justifyContent:'space-between'};
      if( Platform.OS === 'web' ) internalContainerStyle.height = "100%";

      buttonTitleColor = appManager.getColorForKey("FeedCardBodyColor");
      style.push({elevation:0});
      if( !this.props.enabled ) style.push({opacity:.4});
      buttonColor = 'transparent';
      return (
        <MKButton
          allowFontScaling={false}
          backgroundColor={buttonColor}
          shadowRadius={0}
          shadowOffset={{width:0, height:0}}
          shadowOpacity={0}
          shadowColor={'transparent'}
          style={style}
          enabled={this.props.enabled}
          rippleColor={appManager.getColorForKey("FeedCardBannerColor", .2)}
          maskBorderRadius={maskBorderRadius}
          testID={text}
          {...other}>
          <View style={internalContainerStyle}>
            { typeof this.props.children !== 'undefined' ? this.props.children : null }
            {
              typeof text !== 'undefined' && text.length > 0 ?
                <ReUpText pointerEvents="none"
                      style={{
                              flex:1,
                              textAlign:'left',
                              marginLeft:8,
                              alignSelf:'center',
                              color: buttonTitleColor,
                              fontFamily: appManager.getFontForKey("Regular"),
                              backgroundColor:'transparent'}}>
                  {text}
                </ReUpText>
              : null
            }
            { typeof this.props.icon !== 'undefined' ?
              <View style={[styles.bannerCircle, {backgroundColor: appManager.getColorForKey("ButtonSecondaryColor"), alignItems:'center', justifyContent:'center'}]}>
                <Icon name={this.props.icon} size={20} color={appManager.getColorForKey("ButtonSecondaryTitleColor")} style={{marginTop:2, backgroundColor:'transparent'}} />
              </View>
            : null }
          </View>
        </MKButton>
      )
    }
    else if( typeof this.props.icon === 'undefined' )
    {
      var internalContainerStyle = {flexDirection:'row', flex:1, justifyContent:'center', alignItems:'center'};
      if( Platform.OS === 'web' ) internalContainerStyle.height = "100%";

      var textStyle = {
              flex:1,
              textAlign:'center',
              lineHeight: 18,
              alignSelf:'center',
              color: buttonTitleColor,
              fontFamily: appManager.getFontForKey("Bold"),
              backgroundColor:'transparent',
              fontWeight: 'bold',
              paddingHorizontal:4};
      if( typeof this.props.fontSize !== 'undefined' ) textStyle.fontSize = this.props.fontSize;
      var shouldShowSquare = appManager.buttonType() == 1;
      var shouldUseShadow = this.props.useShadow && appManager.buttonType() != 2;
      if( appManager.buttonType() == 2 && this.props.isSecondary )
      {
        style = StyleSheet.flatten([style, {borderColor:appManager.getColorForKey("ButtonPrimaryColor"), borderWidth:'1', borderStyle:'solid', borderRadius:8}]);
      }
      else if( appManager.buttonType() == 2 )
      {
        style = StyleSheet.flatten([style, {borderRadius:8, borderColor:appManager.getColorForKey("ButtonSecondaryColor"), borderWidth:'1', borderStyle:'solid', borderRadius:8}]);
      }
      return (
        <MKButton
          allowFontScaling={false}
          backgroundColor={buttonColor}
          shadowRadius={2}
          shadowOffset={{width:0, height:2}}
          shadowOpacity={0.9}
          shadowColor={shouldShowSquare ? buttonBorderColor : 'transparent'}
          style={style}
          rippleColor={rippleColor}
          maskBorderRadius={maskBorderRadius}
          testID={text}
          disableBorder={appManager.buttonType() != 2}
          {...other}>
          { shouldShowSquare ? <View style={{position:'absolute', top:3, bottom:3, left:3, right:3, borderColor:buttonTitleColor, borderWidth:1, borderStyle:'solid'}} /> : null }
          <View style={internalContainerStyle}>
            { typeof this.props.icon !== 'undefined' ? <Icon name={this.props.icon} size={30} color={buttonTitleColor}/> : null }
            { typeof this.props.children !== 'undefined' ? this.props.children : null }
            {
              typeof text !== 'undefined' && text.length > 0 ?
                <ReUpText isTitle={true} pointerEvents="none" appManager={appManager}
                      style={textStyle}>
                  {text}
                </ReUpText>
              : null
            }
          </View>
        </MKButton>
      )
    }
    else
    {
      var internalContainerStyle = {flexDirection:'row', alignItems:'center', justifyContent:'space-between'};
      if( Platform.OS === 'web' ) internalContainerStyle.height = "100%";

      var textStyle = {
              textAlign:'center',
              lineHeight:24,
              alignSelf:'center',
              color: buttonTitleColor,
              fontFamily: appManager.getFontForKey("Bold"),
              backgroundColor:'transparent',
              fontWeight: 'bold',}
      if( typeof this.props.fontSize !== 'undefined' ) textStyle.fontSize = this.props.fontSize;

      return (
        <MKButton
          backgroundColor={buttonColor}
          shadowRadius={2}
          shadowOffset={{width:0, height:2}}
          shadowOpacity={0.9}
          shadowColor={this.props.useShadow ? buttonBorderColor : 'transparent'}
          style={style}
          rippleColor={rippleColor}
          maskBorderRadius={maskBorderRadius}
          {...other}>
          <View style={internalContainerStyle}>
            { typeof this.props.icon !== 'undefined' ? <View style={{flex:1, paddingLeft:typeof this.props.iconPaddingLeft !== 'undefined' ? this.props.iconPaddingLeft : 0}}><Icon name={this.props.icon} size={typeof this.props.iconSize === 'undefined' ? 30 : this.props.iconSize} color={buttonTitleColor}/></View> : null }
            { typeof this.props.children !== 'undefined' ? this.props.children : null }
            {
              typeof text !== 'undefined' && text.length > 0 ?
                <View style={{flex:-1, justifyContent:'flex-start', flexDirection:'row'}}>
                  <ReUpText isTitle={true} pointerEvents="none" appManager={appManager}
                        style={textStyle}>
                    {text}
                  </ReUpText>
                </View>
              : null
            }
            {
              typeof this.props.icon !== 'undefined' ?
                <View style={{flex:1, justifyContent:'flex-end', flexDirection:'row'}}>
                {
                  typeof this.props.rightIcon !== 'undefined' ?
                    <Icon name={this.props.rightIcon} size={typeof this.props.iconSize === 'undefined' ? 30 : this.props.iconSize} color={buttonTitleColor}/>
                  : null
                }
                </View>
               : null
             }
          </View>

        </MKButton>
      )
    }
  }
});

var styles = StyleSheet.create({
  bannerCircle: {
    width:25,
    height:25,
    borderRadius:25/2,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    marginRight: 3
  },
});

module.exports = ReUpButton;



// WEBPACK FOOTER //
// ./src/ReUpButton.js